// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

export function environmentOverride() {
    /**
     * Options: DEV, LOCALHOST, INT, PROD (not case sensitive)
     */
    return 'INT';
}
